import { Button, Switch } from 'geniebook-ui/dist';
import React, { useEffect, useState } from 'react';

export type TimedWorksheetOptionHorizontalProps = {
  createWorksheet: () => void;
  onSetTimedWorksheet: (isTimed: boolean) => void;
  isSubscriptionDelayed?: boolean;
  className?: string;
  handleShowSubscriptionDelayedError: () => void;
};

const TimedWorksheetOptionHorizontal = ({
  createWorksheet,
  onSetTimedWorksheet,
  isSubscriptionDelayed,
  className = '',
  handleShowSubscriptionDelayedError,
}: TimedWorksheetOptionHorizontalProps) => {
  const [isUsingTimed, setIsUsingTimed] = useState(false);

  const onCheckTimed = () => {
    if (isSubscriptionDelayed) return;

    setIsUsingTimed(!isUsingTimed);
  };

  useEffect(() => {
    onSetTimedWorksheet(isUsingTimed);
  }, [isUsingTimed]);

  return (
    <div
      className={
        'w-full text-neutral-chalk flex items-center px-6 py-3 rounded-2xl bg-primary-navyblue-shade ' +
        className
      }
    >
      <div className={'mr-2'}>
        <Switch
          checked={isUsingTimed}
          onClick={() => {
            onCheckTimed();
          }}
        />
      </div>
      <span className="font-black mr-auto">Timed Worksheet</span>
      <Button
        className={`!max-w-[240px] !font-black !h-[38px]`}
        onClick={() => {
          if (isSubscriptionDelayed) handleShowSubscriptionDelayedError();
          else createWorksheet();
        }}
        disabled={false}
      >
        Create worksheet
      </Button>
    </div>
  );
};

export default TimedWorksheetOptionHorizontal;
